<template>
  <div class="haulage-revenue-main">
    <!-- Left sidebar for date and filters -->
    <div class="left-container">
       <div class="section-loader" v-if="filterLoader">
        <div class="section-loader-text">{{sectionLoaderText}}</div>
      </div>
      <div class="date-section">
        <div style="flex-grow: 1;">
          <span>Ready for Billing Date</span>
          <DateTimePicker title="From" placeholder="From" :showTime="true" :value.sync="fromDate" />
          <DateTimePicker title="To" placeholder="To" :showTime="true" :value.sync="toDate" />
        </div>
        <button @click="refreshClicked">Refresh</button>
      </div>
      <div class="filter-table">
        <Filters class="customer-filter" title="Customer" :tableData="customerData" itemKey="Customer Code" itemDesc="Customer Name" @confirmClicked="filterCustConfirm"/>
        <Filters class="jobtype-filter" title="Job Type" :tableData="jobData" itemKey="JobType" itemDesc="Description" @confirmClicked="filterJobConfirm"/>
        <Filters class="tariffarea-filter" title="Tariff Area" :tableData="areaData" itemKey="Area Code" itemDesc="Description" @confirmClicked="filterAreaConfirm"/>
      </div>
    </div>
    <!-- Right section -->
    <div class="right-container">
      <!-- Top bar showing filter selections -->
      <div class="filtered-section">
         <div class="section-loader" v-if="filterLoader">
        <div class="section-loader-text">{{sectionLoaderText}}</div>
      </div>
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title-long">Ready for Billing Date</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ fromDateInfo }} to {{ toDateInfo }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title-long">Customer</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredCustomer.length == 0 ? 'All' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(', ')">{{ filteredCustomer.length == 0 ? 'All' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(',') }}</div>
          </div>
        </div>
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title">Job Type</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredJobType.length == 0 ? 'All' : filteredJobType.map((s) => { return s['JobType'] }).join(', ')">{{ filteredJobType.length == 0 ? 'All' : filteredJobType.map((s) => { return s['JobType'] }).join(',') }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Tariff Area</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredArea.length == 0 ? 'All' : filteredArea.map((s) => { return s['Area Code'].split(' ').join('') }).join(', ')">{{ filteredArea.length == 0 ? 'All' : filteredArea.map((s) => { return s['Area Code'].split(' ').join('') }).join(',') }}</div>
          </div>
        </div>
        <div class="refresh-section">
          <div v-if="!filterLoader">Last Refreshed : {{refreshDate}}</div>
        </div>
      </div>
      <!-- Top chart for Revenue by Prime Mover -->
      <div class="hms-chart-table" id="hms-chart-table">
        <div class="section-loader" v-if="revenuebyPMLoader">
          <div class="section-loader-text">{{sectionLoaderText}}</div>
        </div>
        <div class="hms-chart-title">Revenue by Prime Mover</div>
        <div class="legend-holder-left" id="legend-holder-pm1"></div>
        <div class="legend-holder-right" id="legend-holder-pm2"></div>
        <div class="hms-chart-container">
          <div class="barlinechart-table" id="barlinechart-table">
          <div class="barlineChart-HMSSales1 ct-golden-section" id="barlineChart-HMSSales1"></div>
          <div class="barline2Chart-HMSSales ct-golden-section" id="barline2Chart-HMSSales"></div>
        </div>
      </div>
      </div>
      <!-- Bottom chart for Revenue by Driver -->
      <div class="hms-chart-table" id="hms-chart-table">
        <div class="section-loader" v-if="revenuebyDriverLoader">
          <div class="section-loader-text">{{sectionLoaderText}}</div>
        </div>
        <div class="hms-chart-title">Revenue by Driver</div>
        <div class="legend-holder-left" id="legend-holder-d1"></div>
        <div class="legend-holder-right" id="legend-holder-d2"></div>
        <div class="hms-chart-container">
          <div class="barlinechart-table" id="barlinechart-table">
          <div class="barlineChart-HMSSales2 ct-golden-section" id="barlineChart-HMSSales2"></div>
          <div class="barline2Chart-HMSSales2 ct-golden-section" id="barline2Chart-HMSSales2"></div>
        </div>
      </div>
      </div>
    </div>
    <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="drillThroughClicked" ref="context"/>
  </div>    
</template>

<script>
/* eslint-disable */
import ContextMenu from '@/components/ContextMenu.vue';
export default {
  components: {
    ContextMenu
  },
  props: {
    // Set starting date as first of the current month
    fromDate: { type: String, default: new Date(new Date().getFullYear(), new Date().getMonth(), 1) }, 
    // Set ending date as the last day of the current month
    toDate: { type: String, default: new Date(new Date().getFullYear(), new Date().getMonth(), new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate())},
    fromDateInfo: { type: String, default: null },
    toDateInfo: { type: String, default: null },
    refreshDate: { type: String, default: new Date() },
    
    customerData: { type: Array, default: function() { return [] } },
    jobData: { type: Array, default: function() { return [] } },
    areaData: { type: Array, default: function() { return [] } },

    selectedCustomer: { type: Array, default: function() { return [] } },
    filteredCustomer: { type: Array, default: function() { return [] } },

    selectedJobType: { type: Array, default: function() { return [] } },
    filteredJobType: { type: Array, default: function() { return [] } },

    selectedArea: { type: Array, default: function() { return [] } },
    filteredArea: { type: Array, default: function() { return [] } },

    getCustomerCode: { type: String, default: '' },
    getJobType: { type: String, default: '' },
    getAreaCode: { type: String, default: '' },

    selectedJobTypeInfo: { type: String, default: '' },
    selectedAreaInfo: { type: String, default: '' },
    selectedCustomerInfo: { type: String, default: '' },

    hmsSalesByPM: {type: Array, default: function() { return [] } },
    hmsSalesByDriver: {type: Array, default: function() { return [] } },

    chartBar: { type: Object, default: function() { return null } },
    chartLine: { type: Object, default: function() { return null } },
    chartBar2: { type: Object, default: function() { return null } },
    chartLine2: { type: Object, default: function() { return null } },

    showContextMenu: { type: Boolean, default: false },
    contextItems: { type: Array, default: function() { return [] } },
    contextPosition: { type: Array, default: function() { return [ 100, 100 ] } },

    filterLoader: { type: Boolean, default: false },
    revenuebyPMLoader: { type: Boolean, default: false },
    revenuebyDriverLoader: { type: Boolean, default: false },
    sectionLoaderText: { type: String, default: 'Loading' },
  },
  methods: {
    filterCustConfirm: function(items) {
      this.selectedCustomer = items;
    },
    filterJobConfirm: function(items) {
      this.selectedJobType = items;
    },
    filterAreaConfirm: function(items) {
      this.selectedArea = items;
    },
    // Run when clicking refresh button
    refreshClicked: async function() {
      this.filterLoader = true;
      this.revenuebyPMLoader = true;
      this.revenuebyDriverLoader = true;
      this.getChartsData();
    },
    // Upon selecting any drill through from context menu, set/clear session storage and route to drill through
    drillThroughClicked: async function(item) {
      sessionStorage.setItem(`Drill Through - DETAILS ${item}`, 
        JSON.stringify(
          { 
            fromDate: this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd HH:mm'), 
            toDate: this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd HH:mm'),
            selectedJobTypeInfo: this.selectedJobTypeInfo,
            selectedCustomerInfo: this.selectedCustomerInfo,
            selectedAreaInfo: this.selectedAreaInfo,
            getJobType: this.getJobType,
            getCustomerCode: this.getCustomerCode,
            getAreaCode: this.getAreaCode,
            lastRefresh: this.refreshDate,
            title: item
          }
        ));
      var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Haulage Revenue by PM & Driver/Drill Through - DETAILS ${item}`);
      window.open(drillThroughLink.href, '_blank');
      sessionStorage.clear();
    },
    // Get filters data and APIs for charts data
    getChartsData: async function(){
      $('#barlineChart-HMSSales1').html('');
      $('#barline2Chart-HMSSales').html('');
      $('#barlineChart-HMSSales2').html('');
      $('#barline2Chart-HMSSales2').html('');
      $('#legend-holder-pm1').html('');
      $('#legend-holder-pm2').html('');
      $('#legend-holder-d1').html('');
      $('#legend-holder-d2').html('');
      if (this.chartBar){
        this.chartBar.detach();
      }
      if (this.chartLine){
        this.chartLine.detach();
      }
      if (this.chartBar2){
        this.chartBar.detach();
      }
      if (this.chartLine2){
        this.chartLine.detach();
      }

      // Get dates for top bar showing filter selection
      this.fromDateInfo = this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd HH:mm');
      this.toDateInfo = this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd HH:mm');
      this.refreshDate = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');

      // Get filter values
      this.filteredCustomer = this.selectedCustomer;
      this.getCustomerCode = this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => { return c['Customer Code'] }).join(',');
      this.filteredJobType = this.selectedJobType;
      this.getJobType = this.filteredJobType.length == 0 ? '' : this.filteredJobType.map((c) => { return c['Job Type'] }).join(',');
      this.filteredArea = this.selectedArea;
      this.getAreaCode = this.filteredArea.length == 0 ? '' : this.filteredArea.map((c) => { return c['Area Code'] }).join(',');
    
      //Get filter values for drill through
      this.selectedCustomerInfo = this.filteredCustomer.length == 0 ? 'All' : this.filteredCustomer.map((c) => { return c['Customer Code'] }).join(',');
      this.selectedJobTypeInfo = this.filteredJobType.length == 0 ? 'All' : this.filteredJobType.map((c) => { return c['Job Type'] }).join(',');
      this.selectedAreaInfo = this.filteredArea.length == 0 ? 'All' : this.filteredArea.map((c) => { return c['Area Code'] }).join(',');

      this.filterLoader = false;

      // Get data from API simultaneously
      // console.log('from: ' + this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd HH:mm'));
      // console.log('to: ' + this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd HH:mm'));
      this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd HH:mm')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd HH:mm')}&datetype=RFB&rpttype=BY_PM&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}`).then((result) => {
        this.hmsSalesByPM = result;
        // console.log(result);
        this.generateRevenueByPM(this.hmsSalesByPM);
        this.revenuebyPMLoader = false;
      });

      this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd HH:mm')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd HH:mm')}&datetype=RFB&rpttype=BY_DRIVER&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}`).then((result) => {
        this.hmsSalesByDriver = result;
        // console.log(result);
        this.generateRevenueByDriver(this.hmsSalesByDriver);
        this.revenuebyDriverLoader = false; 
      });
    },
    // Generate Revenue by Prime Mover bar-line charts
    generateRevenueByPM: async function(data) {
      if(data.includes('error')){
        document.getElementById('barlineChart-HMSSales1').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      }
      else if(data.length == 0){
        document.getElementById('barlineChart-HMSSales1').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      }
      else {
        var dynamicSeriesName = Object.keys(data[0]).filter((o) => { return  o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'TotalCont' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
        var dynamicSeries = dynamicSeriesName.map((d) => {
          return {
            name: d,
            data: data.map((p) => { return p[d] })
          }
        });
        var value = dynamicSeriesName.map((d) => {
          return {
            data: Math.max(...data.map((p) => { return p[d] })),
            data1: Math.min(...data.map((p) => { return p[d] }))
          }
        })
        var maxValue = Math.max(...value.map((p) => { return p.data }));
        var minValue = Math.min(...value.map((p) => { return p.data1 }));
        var dynamicSeriesName2 = Object.keys(data[0]).filter((o) => { return o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'AmtTotal' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
        var dynamicSeries2 = dynamicSeriesName2.map((d) => {
            return {
              name: d,
              data: data.map((p) => { return p[d] })
            }
        });
        var value2 = dynamicSeriesName2.map((d) => {
            return {
              data: Math.max(...data.map((p) => { return p[d] })),
              data1: Math.min(...data.map((p) => { return p[d] }))
            }
          });
        var maxValue2 = Math.max(...value2.map((p) => { return p.data }));
        var minValue2 = Math.min(...value2.map((p) => { return p.data1 }));
        var maxValueTopChart = Math.max(maxValue, maxValue2);
        var minValueTopChart = Math.min(minValue, minValue2);
      
      // Legend positions
      var legendsChart1 = document.getElementById('legend-holder-pm1');
      var legendsChart2 = document.getElementById('legend-holder-pm2');

      // Chartist bar chart
      this.chartBar = new Chartist.Bar('.barlineChart-HMSSales1', {
          labels: data.map((m) => { return m['XAxis'] }),
          series: dynamicSeries
      }, {
          chartPadding: {top: 10,right: 20,bottom: 20,left: 20},
          fullWidth: true,  
          high: maxValueTopChart,
          low: minValueTopChart,
          seriesBarDistance: 10,
          axisY: {offset: 10, scaleMinSpace: 20, showLabel: true},
          plugins: [ Chartist.plugins.legend( { legendNames: ['Total Revenue'], position: legendsChart1, className: "barlineChart-HMSSales1"} ) ]
      });

      // Chartist line chart
      this.chartLine = new Chartist.Line('.barline2Chart-HMSSales', {
            series: dynamicSeries2
          }, 
          {
           chartPadding: {top: 10,right: 40,bottom: 20,left: 50},
            fullWidth: true, 
            high: maxValue2, 
            low: minValue2,
            axisY: {offset: -4, onlyInteger: true, scaleMinSpace: 20, showLabel: true, showGrid: false, position:'right'},
            axisX: {showGrid: false},
            plugins: [ Chartist.plugins.legend( { legendNames: ['Total Container'], position: legendsChart2, className: "barline2Chart-HMSSales"} ) ]
          });
      }

      // Tooltip
      if (this.chartLine){
        var $tooltip = $('<div class="tooltip tooltip-hidden" style="z-index:6"></div>').appendTo($('.barline2Chart-HMSSales'));
        $('#barline2Chart-HMSSales').on('mouseenter', '.ct-point', function() {
          var seriesName = $(this).closest('.ct-series').attr('ct:series-name'), value = $(this).attr('ct:value');
          $tooltip.html("<span>" + seriesName + "<br/> " + value);
          $tooltip.removeClass('tooltip-hidden');
        });
        $('#barline2Chart-HMSSales').on('mouseleave', '.ct-point', function() {
          $tooltip.addClass('tooltip-hidden');
        });
        $('#barline2Chart-HMSSales').on('mousemove', '.ct-point', function(event) {
          $tooltip.css({
            left: event.pageX - 390,
            top: event.pageY - 187
          });
        });
      }

      // Context menu
      var mainContainer = this;
      $('document').ready(() => {
        $(document).on('click', '.barline2Chart-HMSSales .ct-point', function(e) {
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ 'Revenue by Prime Mover Details', 'Consignment Details' ];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 60), e.clientX + 15 ];
          });
        });
      });
    },
    // Generate Revenue by Driver chart
    generateRevenueByDriver: async function(data) {
      if(data.includes('error')){
        document.getElementById('barlineChart-HMSSales2').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      }
      else if(data.length == 0){
        document.getElementById('barlineChart-HMSSales2').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      }
      else {
        var dynamicSeriesName = Object.keys(data[0]).filter((o) => { return  o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'TotalCont' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
        var dynamicSeries = dynamicSeriesName.map((d) => {
          return {
            name: d,
            data: data.map((p) => { return p[d] })
          }
        });
        var value = dynamicSeriesName.map((d) => {
          return {
            data: Math.max(...data.map((p) => { return p[d] })),
            data1: Math.min(...data.map((p) => { return p[d] }))
          }
        })
        var maxValue = Math.max(...value.map((p) => { return p.data }));
        var minValue = Math.min(...value.map((p) => { return p.data1 }));
        var dynamicSeriesName2 = Object.keys(data[0]).filter((o) => { return o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'AmtTotal' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
        var dynamicSeries2 = dynamicSeriesName2.map((d) => {
            return {
              name: d,
              data: data.map((p) => { return p[d] })
            }
        });
        var value2 = dynamicSeriesName2.map((d) => {
            return {
              data: Math.max(...data.map((p) => { return p[d] })),
              data1: Math.min(...data.map((p) => { return p[d] }))
            }
          });
        var maxValue2 = Math.max(...value2.map((p) => { return p.data }));
        var minValue2 = Math.min(...value2.map((p) => { return p.data1 }));
        var maxValueTopChart = Math.max(maxValue, maxValue2);
        var minValueTopChart = Math.min(minValue, minValue2);
      
      // Legend positions
      var legendsChart1 = document.getElementById('legend-holder-d1');
      var legendsChart2 = document.getElementById('legend-holder-d2');

      // Chartist bar chart
      this.chartBar2 = new Chartist.Bar('.barlineChart-HMSSales2', {
          labels: data.map((m) => { return m['XAxis'] }),
          series: dynamicSeries
      }, {
          chartPadding: {top: 10,right: 20,bottom: 20,left: 20},
          fullWidth: true,  
          high: maxValueTopChart,
          low: minValueTopChart,
          seriesBarDistance: 10,
          axisY: {offset: 10, scaleMinSpace: 20, showLabel: true},
          plugins: [ Chartist.plugins.legend( { legendNames: ['Total Revenue'], position: legendsChart1, className: "barlineChart-HMSSales2"} ) ]
      });

      // Chartist line chart
      this.chartLine2 = new Chartist.Line('.barline2Chart-HMSSales2', {
            series: dynamicSeries2
          }, 
          {
           chartPadding: {top: 10,right: 40,bottom: 20,left: 50},
            fullWidth: true, 
            high: maxValue2, 
            low: minValue2,
            axisY: {offset: -4, onlyInteger: true, scaleMinSpace: 20, showLabel: true, showGrid: false, position:'right'},
            axisX: {showGrid: false},
            plugins: [ Chartist.plugins.legend( { legendNames: ['Total Container'], position: legendsChart2, className: "barline2Chart-HMSSales2"} ) ]
          });
      }

      // Tooltip
      if (this.chartLine2){
        var $tooltip2 = $('<div class="tooltip tooltip-hidden" style="z-index:6"></div>').appendTo($('.barline2Chart-HMSSales2'));
        $('#barline2Chart-HMSSales2').on('mouseenter', '.ct-point', function() {
          var seriesName = $(this).closest('.ct-series').attr('ct:series-name'), value = $(this).attr('ct:value');
          $tooltip2.html("<span>" + seriesName + "<br/> " + value);
          $tooltip2.removeClass('tooltip-hidden');
        });
        $('#barline2Chart-HMSSales2').on('mouseleave', '.ct-point', function() {
          $tooltip2.addClass('tooltip-hidden');
        });
        $('#barline2Chart-HMSSales2').on('mousemove', '.ct-point', function(event) {
          $tooltip2.css({
            left: event.pageX - 390,
            top: event.pageY - 502
          });
        });
      }

      // Context menu 
      var mainContainer = this;
      $('document').ready(() => {
        $(document).on('click', '.barline2Chart-HMSSales2 .ct-point', function(e) {
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ 'Revenue by Driver Details' ];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 25), e.clientX + 15];
          });
        });
      });   
    }
  },
  async mounted() {
    this.filterLoader = true;
    this.revenuebyPMLoader = true;
    this.revenuebyDriverLoader = true;

    // Filter APIs 
    this.customerData = await this.$apiCallV2('/HaulageRevenue/GetListMaster?masterFile=BILLCUSTNAME');
    this.jobData = await this.$apiCallV2(`/HaulageRevenue/GetListMaster?masterFile=SYSTEM_JOBTYPE&module=HMS`);
    this.areaData = await this.$apiCallV2('/HaulageRevenue/GetListMaster?masterFile=area');

    // Get filters data and APIs for charts data
    this.getChartsData();
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.haulage-revenue-main{
  display: flex;
  padding: 5px 45px;
  width: 100%;
  height: 100%;
  font-size: 12px;
  overflow-x: hidden;
  > .left-container{
    height: 100%;
    min-width: 300px;
    max-width: 300px;
    background-color: white;
    border-radius: 5px;
    margin-right: 5px;
    position: relative;
    overflow: hidden;
    > .date-section{
      height: 80px;
      display: flex;
      align-items: center;
      padding: 10px 5px 0 5px;
    }
    
    > .filter-table{
      width: 100%; 
      height: calc( 100% - 125px); 
      flex-grow: 1;
      >.customer-filter{
        width: 100%; 
        height: calc( 100% - 67%);
        padding: 5px 5px 0 5px;
      }
      >.jobtype-filter{
        width: 100%; 
        height: 33%; 
        padding: 0 5px 0 5px;
      }
      >.tariffarea-filter{
        width: 100%; 
        height: 33%;
        padding: 0 5px 0 5px;  
      }
    }
  }
  > .right-container{
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    > .filtered-section {
      width: 100%;  
      height: auto;
      background-color: white;
      border-radius: 5px;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 8;
      display: flex;
      align-items: center;
      margin-bottom: 3px;
      overflow-x: auto;
      overflow-y: hidden;
      > .filtered-items {
        width: calc(100% - 250px);
        > .filtered-row {
          display: flex;
          align-items: center;
          > .filter-title-long {
            width: 270px;
            padding-left:3px;
          }
          > .filter-title {
            width: 120px;
            padding-left:3px;
          }
          > .colon-separator {
            margin: 0 5px;
          }
          > .filter-details {
            width: 100%;
          }
        }
      }
      > .refresh-section {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        white-space: nowrap;
        margin-right: 3px;
      }
    }
  }
  .hms-chart-table{
    width: 100%;
    height: calc((100% - 45px) / 2);
    overflow: hidden;
    margin-bottom: 3px;
    background-color: white;
    border-radius: 5px;
    position: relative;
  }  
  .hms-chart-title{
    height: auto;
    width:  calc( 100% - 10px);
    margin-left: 10px;
    font-size: 12px;
    color: black;
    font-weight: bold;
  }
  .legend-holder-left{
    white-space: nowrap;
    width:25%;
    float:left;
    height:20px;
    margin:5px 0 0 0;
    padding-left:3px;
  }
  .legend-holder-right{
    white-space: nowrap;
    float:right;
    height:20px;
    margin: 5px 15px 0 0
  }
  .hms-chart-container{
    width: 100%;
    height: 90%;
    display: flex;
    padding-left:3px;
    padding-right:3px;
    padding-top:5px;
  }
  .barlinechart-table{
    width: 100%;
    height: 100%;
    position: relative;
    margin-top:-5px;
  }
  .barlineChart-HMSSales1, .barlineChart-HMSSales2{
    width: 100%;
    height: 100%;
    font-size: 10px;
    color: black;
  }
  .barline2Chart-HMSSales, .barline2Chart-HMSSales2{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
  }
  // CSS for section loaders for section loading
  .section-loader {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 1000;

    > .section-loader-text {
      width: auto;
      height: 30px;
      padding: 10px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0 0 8px #0004;
      user-select: none;
    }
  }
}
</style>